<style type="text/css">
/* .dateTime {
    width: auto !important;
}
.dateTime .field-input {
    color: rgb(0, 168, 255) !important;
    padding: 2px !important;
    font-size: 12px !important;
    border: 0 !important;
}
.dateTime input::placeholder {
    color: rgb(0, 168, 255) !important;
    font-weight: 400;
} */

.test-query-input .field-input {
  padding: 0px 10px;
  font-size: 13px;
  line-height: 1.42857143;
  background-color: #fff;
  background-image: none;
  border-color: transparent;
  border-radius: 0;
  -webkit-box-shadow: inset 0 0 0 transparent;
  box-shadow: inset 0 0 0 transparent;
  -webkit-transition: border-color ease-in-out .15s, -webkit-box-shadow ease-in-out .15s;
  -o-transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;
  transition: border-color ease-in-out;
  border: 0 !important;
  border-bottom: 1px solid #e7eff3 !important;
  height: 35px;
  font-weight: 500;
  width: 100%;
  color: #253858;
}

.test-query-input .field-input:focus {
  outline: none;
  border: 0 !important;
}

</style>
<template>
  <div class="position-relative test-query-input">
    <VueCtkDateTimePicker
        v-if="field.type == 'date'"
        format="YYYY/MM/DD"
        formatted="DD/MM/YYYY"
        v-model="dateTime"
        :no-label="true"
        :noClearButton="true"
        label=""
        :only-date="true"
        :position="'bottom'"
    />
    <VueCtkDateTimePicker
        v-else
        format="YYYY/MM/DD hh:mm a"
        formatted="DD/MM/YYYY hh:mm a"
        v-model="dateTime"
        :no-label="true"
        :noClearButton="true"
        label=""
        :position="'bottom'"
    />
  </div>
</template>
<script>
export default {
  props: [
    'field', // table field
    'SelectedTabledateTime',
  ],
  data() {
    return {}
  },
  mounted() {

  },
  created() {

  },
  computed: {
    dateTime: {
      get() {
        return this.getMapedValue();
      },
      set(newVal) {
        this.SetDateTime(newVal);
      }
    }
  },
  beforeMount() {

  },
  methods: {
    SetDateTime(value) {

      if (value) {
        let data = {
          value: value,
          name: this.field.name,
        };
        this.$emit('querySimulationDateTime', data);
      }
    },
    getMapedValue() {

      let dateTimeDetails = null;

      let _index = this.SelectedTabledateTime.findIndex(x => x.name == this.field.name);

      if (_index > -1) {
        dateTimeDetails = this.SelectedTabledateTime[_index].value;
      } else {
        dateTimeDetails = null;
      }

      return dateTimeDetails;
    }
  }
}
</script>